import { Card } from '@delmonicos/shared-design-system-react/src/components/card/card';
import { Divider } from '@delmonicos/shared-design-system-react/src/components/divider/divider';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import {
  Text,
  TextColor,
  TextFontSize,
} from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { AccentTitle } from '@delmonicos/shared-design-system-react/src/components/typography/title/accent-title/accent-title';
import { HeadingEnum } from '@delmonicos/shared-design-system-react/src/models/enums/heading.enum';
import { formatDate } from '@delmonicos/shared-sdk/libs/cpms/src/clients/utils/formatters/format-date';
import { useTranslation } from 'react-i18next';

import i18n from '@app/core/locale/i18n';

import { useTokenContext } from '../../token.context';

export const InformationCardComponent = (): React.JSX.Element => {
  const { t } = useTranslation();

  // CONTEXT ///////////////////////////////////////////////////////////////////

  const token = useTokenContext();

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Card flex={1} gap={GapEnum.M} direction="column">
      <Stack gap={GapEnum.S} justifyContent="space-between" alignItems="center">
        <AccentTitle
          icon="info-circle"
          as={HeadingEnum.H2}
          text={t('$.token-details.information.title')}
        />
        <Stack gap={GapEnum.S}>
          <Text color={TextColor.Disabled} fontSize={TextFontSize.Medium}>
            {t('delmonicos-shared-sdk.outputs-token.uid')}
          </Text>
          <Text
            truncate
            color={TextColor.Disabled}
            fontSize={TextFontSize.Medium}>
            {token.id}
          </Text>
        </Stack>
      </Stack>
      <Stack gap={GapEnum.S} justifyContent="space-between" alignItems="center">
        <Stack flex={1}>
          <Text
            color={TextColor.Secondary}
            uppercase
            fontSize={TextFontSize.Small}>
            {t('$.token-details.company-name')}
          </Text>
        </Stack>
        <Stack flex={1}>
          <Text>-{/* {token.companyName ?? '-'} */}</Text>
        </Stack>
      </Stack>
      <Stack gap={GapEnum.S} justifyContent="space-between" alignItems="center">
        <Stack flex={1}>
          <Text
            color={TextColor.Secondary}
            uppercase
            fontSize={TextFontSize.Small}>
            {t('delmonicos-shared-sdk.outputs-token.first-name')} -{' '}
            {t('delmonicos-shared-sdk.outputs-token.last-name')}
          </Text>
        </Stack>
        <Stack flex={1}>
          <Text>
            {token.firstName} - {token.lastName}
          </Text>
        </Stack>
      </Stack>
      <Stack gap={GapEnum.S} justifyContent="space-between" alignItems="center">
        <Stack flex={1} alignItems="center">
          <Text
            color={TextColor.Secondary}
            uppercase
            fontSize={TextFontSize.Small}>
            {t('delmonicos-shared-sdk.outputs-token.expiration-date')}
          </Text>
        </Stack>
        <Stack flex={1} alignItems="center">
          <Text>
            {token.expirationDate
              ? formatDate(token.expirationDate, i18n)
              : '-'}
          </Text>
        </Stack>
      </Stack>
      <Stack gap={GapEnum.S} justifyContent="space-between" alignItems="center">
        <Stack flex={1} alignItems="center">
          <Text
            color={TextColor.Secondary}
            uppercase
            fontSize={TextFontSize.Small}>
            {t('delmonicos-shared-sdk.outputs-token.comment')}
          </Text>
        </Stack>
        <Stack flex={1} alignItems="center">
          <Text>{token.comment ?? '-'}</Text>
        </Stack>
      </Stack>
      <Divider />
      <Stack gap={GapEnum.S} justifyContent="space-between" alignItems="center">
        <Stack flex={1} alignItems="center">
          <Text
            color={TextColor.Secondary}
            uppercase
            fontSize={TextFontSize.Small}>
            {t('delmonicos-shared-sdk.outputs-token.uid')}
          </Text>
        </Stack>
        <Stack flex={1} alignItems="center">
          <Text>{token.uid ?? '-'}</Text>
        </Stack>
      </Stack>
      <Stack gap={GapEnum.S} justifyContent="space-between" alignItems="center">
        <Stack flex={1} alignItems="center">
          <Text
            color={TextColor.Secondary}
            uppercase
            fontSize={TextFontSize.Small}>
            {t('delmonicos-shared-sdk.outputs-token.visual-number')}
          </Text>
        </Stack>
        <Stack flex={1} alignItems="center">
          <Text>{token.visualNumber ?? '-'}</Text>
        </Stack>
      </Stack>
      <Stack gap={GapEnum.S} justifyContent="space-between" alignItems="center">
        <Stack flex={1} alignItems="center">
          <Text
            color={TextColor.Secondary}
            uppercase
            fontSize={TextFontSize.Small}>
            {t('$.token-details.contract-number')}
          </Text>
        </Stack>
        <Stack flex={1} alignItems="center">
          <Text>{token.visualNumber ?? token.authId ?? '-'}</Text>
        </Stack>
      </Stack>
    </Card>
  );
};
